(function () {
  var CHIPS = ['Size', 'Year'];
  var SHOW = 8;
  function label(d) { var s = d.querySelector('.mobile-facets__summary span'); return s ? s.textContent.trim() : ''; }
  function setup(root) {
    root.querySelectorAll('details.mobile-facets__details.js-filter').forEach(function (d) {
      if (!d.hasAttribute('open')) d.setAttribute('open', '');
      var name = label(d);
      if (CHIPS.indexOf(name) > -1) d.setAttribute('data-fv-chips', '');
      var list = d.querySelector('.mobile-facets__list');
      if (!list || list.dataset.fvDone) return;
      list.dataset.fvDone = '1';
      d.querySelectorAll('.fv-facet-search, .fv-facet-more').forEach(function (el) { el.remove(); });
      var items = Array.prototype.slice.call(list.children);
      items.forEach(function (li) { li.classList.remove('fv-more-hidden'); });
      if (name === 'Size') {
        items.forEach(function (li) {
          var lab = li.querySelector('.facet-checkbox__text-label');
          if (!lab) return;
          var txt = lab.textContent.trim();
          if (/^\d+$/.test(txt) && !li.querySelector('input:checked')) { li.classList.add('fv-more-hidden'); return; }
          if (/years/i.test(txt)) { lab.textContent = txt.replace(/^Kids\s*/i, 'Kids ').replace(/\s*years/i, ''); li.classList.add('fv-wide'); }
        });
        items = items.filter(function (li) { return !li.classList.contains('fv-more-hidden'); });
      }
      if (name === 'Brand' || name === 'Team' || name === 'League') {
        var num = function (li) { var m = li.textContent.match(/\((\d+)\)/); var n = m ? parseInt(m[1], 10) : 0; return li.querySelector('input:disabled') ? -1 : n; };
        var pos = items.map(function (li, i) { return [li, i]; });
        pos.sort(function (a, b) { var x = num(a[0]), y = num(b[0]); return name === 'Brand' ? (y - x) || (a[1] - b[1]) : ((x < 0) - (y < 0)) || (a[1] - b[1]); });
        items = pos.map(function (p) { return p[0]; });
        items.forEach(function (li) { list.appendChild(li); });
      }
      var more = null;
      var checked = items.some(function (li, i) { return i >= SHOW && li.querySelector('input:checked'); });
      if (name !== 'Size' && items.length > SHOW + 2 && !checked) {
        items.forEach(function (li, i) { if (i >= SHOW) li.classList.add('fv-more-hidden'); });
        more = document.createElement('button');
        more.type = 'button'; more.className = 'fv-facet-more'; more.textContent = '+ ' + (items.length - SHOW) + ' more';
        more.addEventListener('click', function () {
          d.dataset.fvAll = '1';
          items.forEach(function (li) { li.classList.remove('fv-more-hidden'); });
          more.hidden = true;
        });
        list.parentNode.insertBefore(more, list.nextSibling);
      }
    });
  }
  var queued = false;
  function run() { queued = false; document.querySelectorAll('.mobile-facets__main').forEach(setup); }
  function later() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (muts[i].type === 'attributes') {
        if (t.matches && t.matches('details.mobile-facets__details.js-filter') && !t.hasAttribute('open')) t.setAttribute('open', '');
      } else { later(); return; }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
  run();
})();
